const disableRightClick = () => {
    const handleContextMenu = (event) => {
        event.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
    };
};

const disableImageDrag = () => {
    const handleDragStart = (event) => {
        if (event.target instanceof HTMLImageElement) {
            event.preventDefault();
        }
    };

    document.addEventListener('dragstart', handleDragStart);

    return () => {
        document.removeEventListener('dragstart', handleDragStart);
    };
};

const disableKeyboardShortcuts = () => {
    const handleKeyDown = (event) => {
        const key = event.key.toLowerCase();
        const isCtrl = event.ctrlKey && !event.metaKey;
        const isCmd = event.metaKey && !event.ctrlKey;
        const isShift = event.shiftKey;
        const isAlt = event.altKey;

        if ((isCtrl || isCmd) && key === 's') {
            event.preventDefault();
            return;
        }

        if ((isCtrl || isCmd) && key === 'u') {
            event.preventDefault();
            return;
        }

        if ((isCtrl && isShift && key === 'i') || (isCmd && isAlt && key === 'i')) {
            event.preventDefault();
            return;
        }

        if (event.key === 'F12') {
            event.preventDefault();
            return;
        }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
        document.removeEventListener('keydown', handleKeyDown);
    };
};

const disableTextSelection = (selector = '.protect') => {
    const elements = Array.from(document.querySelectorAll(selector));
    const originalStyles = elements.map((element) => ({
        element,
        userSelect: element.style.userSelect || '',
        webkitUserSelect: element.style.webkitUserSelect || '',
    }));

    elements.forEach((element) => {
        element.style.userSelect = 'none';
        element.style.webkitUserSelect = 'none';
    });

    return () => {
        originalStyles.forEach(({ element, userSelect, webkitUserSelect }) => {
            if (userSelect) {
                element.style.userSelect = userSelect;
            } else {
                element.style.removeProperty('user-select');
            }

            if (webkitUserSelect) {
                element.style.webkitUserSelect = webkitUserSelect;
            } else {
                element.style.removeProperty('-webkit-user-select');
            }
        });
    };
};

const addImageOverlay = () => {
    const overlays = [];

    const images = Array.from(document.querySelectorAll('.image-slot-filled img'));

    images.forEach((image) => {
        const parent = image.parentElement;
        let wrapper = parent;
        let createdWrapper = false;

        if (!parent || parent.style.position === 'static') {
            wrapper = document.createElement('div');
            wrapper.style.position = 'relative';
            wrapper.style.display = 'inline-block';
            wrapper.className = 'content-protection-image-wrapper';

            if (parent) {
                parent.replaceChild(wrapper, image);
            }

            wrapper.appendChild(image);
            createdWrapper = true;
        }

        const overlay = document.createElement('div');
        overlay.style.position = 'absolute';
        overlay.style.inset = '0';
        overlay.style.zIndex = '10';
        overlay.style.pointerEvents = 'auto';
        overlay.style.background = 'transparent';

        wrapper.appendChild(overlay);
        overlays.push(overlay);

        if (createdWrapper) {
            overlay.dataset.contentProtectionWrapper = 'true';
        }
    });

    return () => {
        overlays.forEach((overlay) => {
            if (overlay.parentElement) {
                overlay.parentElement.removeChild(overlay);
            }
        });
    };
};

export {
    disableRightClick,
    disableImageDrag,
    disableKeyboardShortcuts,
    disableTextSelection,
    addImageOverlay,
};
